import React, { useState, useEffect } from "react";
import "./ContactUs.css";

const ContactUs = () => {
  useEffect(() => {
  document.title = "Contact-us | Qnexa Services — Trusted by Industry Leaders";
}, []);

  const accessKey = "807c811b-27c7-43e8-a661-517a0ee9f4e0";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    hear: "",
    message: "",
    consent: false,
    resume: null,
  });

  const [toast, setToast] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("access_key", accessKey);
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("company", formData.company);
    data.append("phone", formData.phone);
    data.append("hear", formData.hear);
    data.append("message", formData.message);
    data.append("consent", formData.consent);

    if (formData.resume) {
      data.append("file", formData.resume);
    }

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: data,
      });

      const result = await response.json();

      if (result.success) {
        setToast(true);
        setTimeout(() => setToast(false), 3000);
        e.target.reset();
        setFormData({
          name: "",
          email: "",
          company: "",
          phone: "",
          hear: "",
          message: "",
          consent: false,
          resume: null,
        });
      } else {
        alert("Error sending form.");
        console.log(result);
      }
    } catch (err) {
      console.log(err);
      alert("Error submitting form.");
    }
  };

  return (
    <div className="contact-wrapper">
      {toast && <div className="toast-message">✔️ Message Sent Successfully!</div>}

      <section className="contact-banner">
        <h1>Contact Us</h1>
      </section>

      <div className="contact-container">
        {/* LEFT SIDE */}
        <div className="contact-left">
          <h2 className="left-title">Our Office</h2>

          <div className="office-item">
            <span className="icon">📍</span>
            <div>
              <strong>Head Office:</strong>
              <address className="footer-address">
                16-58/8, YSR Colony,<br />
                VTC: Narasapuram,<br />
                PO: Narsapur,<br />
                District: West Godavari,<br />
                State: Andhra Pradesh,<br />
                PIN Code: 534275,<br />
                India.
              </address>
            </div>
          </div>

          <div className="office-item">
            <span className="icon">📞</span>
            <p>8978418889</p>
          </div>

          <div className="office-item">
            <span className="icon">✉️</span>
            <p>qnexservices@gmail.com</p>
          </div>

          <h2 className="left-title" style={{ marginTop: "28px" }}>Business Hours</h2>
          <div className="office-item">
            <span className="icon">⏳</span>
            <p>Monday - Saturday: 09:30 to 18:30</p>
          </div>
          <div className="office-item">
            <span className="icon">⏳</span>
            <p>Sunday - Closed</p>
          </div>
        </div>

        {/* FORM */}
        <form className="contact-right" onSubmit={handleSubmit}>
          <h2 className="right-title">Get In Touch</h2>
          <p className="right-sub">Let's connect and explore how our solutions can empower your success.</p>

          <div className="form-row">
            <input name="name" type="text" placeholder="Name" onChange={handleChange} required />
            <input name="email" type="email" placeholder="Email" onChange={handleChange} required />
          </div>

          <input
            name="company"
            type="text"
            placeholder="Company Name"
            className="full-input"
            onChange={handleChange}
          />

          <input
            type="tel"
            name="phone"
            className="full-input"
            placeholder="Phone Number"
            onChange={handleChange}
            required
          />

          <select name="hear" className="full-input" onChange={handleChange}>
            <option value="">From where did you hear about us?</option>
            <option>Google</option>
            <option>Facebook</option>
            <option>LinkedIn</option>
            <option>Friend / Referral</option>
          </select>

          <textarea
            name="message"
            placeholder="Message"
            rows="6"
            className="full-input"
            onChange={handleChange}
            required
          ></textarea>

          <div className="consent">
            <input type="checkbox" name="consent" onChange={handleChange} required />
            <p>
              I affirm that I have carefully reviewed the Data Protection Declaration. I hereby grant consent.
            </p>
          </div>

          <button className="send-btn" type="submit">SEND MESSAGE</button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
